import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/angular'; // useful for typechecking
import { TimeSheetDayInfo, TimeSheetInfo } from '../model/timesheet.model';
import { environment } from 'src/environments/environment';
import { TimeSheetDetailInfo } from '../model/timesheetDetailInfo.model';
import { LookupInfo } from '../model/lookup.model';
import { TimeSheetMappingProjectInfo } from '../model/timesheetMappingProject.model';
import { TimeSheetHoursInfo } from '../model/TimeSheetHours.model';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { AnnounceInfo } from '../model/announce.model';
import { ExpenseClaimsInfo, ExpenseClaimsItemInfo } from '../model/ExpenseClaims.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.css']
})
export class TimesheetComponent implements OnInit {
  /******************************** Variable ************************************ */
  baseurl: string;
  expense_baseurl: string;
  calendarOptions: CalendarOptions
  customCalendar: TimeSheetInfo;

  _EmpCode: string;   

  tsCode: string;
  tsDetails: TimeSheetDetailInfo[] = [];
  tsLeaveTypes: LookupInfo[] = [];
  tsLeaveApplyTypes: LookupInfo[] = [];
  tsMappingProject: TimeSheetMappingProjectInfo[] = [];
  tsMappedProjects: TimeSheetMappingProjectInfo[] = [];
  tsHoursDetails: TimeSheetHoursInfo[] = [];
  tsAnnounces: AnnounceInfo[] = [];

  dateValue: string;
  monthValue: number;
  yearValue: number;
  weekValue: number;
  tempDay: string;

  public ddlLeaveType: string;
  public ddlLeaveApplyType: number;
  selectedLeaveType: string = "";
  selectedLeaveApplyType: number = 0;
  leaveStartDate: string;
  leaveEndDate: string;
  txtSchProjectCodeOrName: string;
  totalProject: number = 0;
  listTsProject: [] = [];
  listTsProjectHours: [] = [];
  RemarkRevise: string = "";
  LeaveText: string = "";
  leaveInfo: any;

  //Modal
  titlemodal: string;
  detailmodal: string;

  //Trigger
  saveTsAllowed: boolean = true;
  dataUpdated: boolean = false;

    //Loading
    displayloading: boolean = false;
  Msgloadding: string = '';
  LoadingManualTrigger: boolean = false;


  // Expense Shortcut
  listofexpensetype: ExpenseClaimsItemInfo[] = [];
  expenseselectedprojcode: string;

  /******************************** Variable ************************************ */

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private elementRef: ElementRef, private formBuilder: FormBuilder, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit() {

    var d = new Date();
    this.dateValue = d.getDate().toString();
    this.monthValue = d.getMonth() + 1;
    this.yearValue = d.getFullYear();

    this._EmpCode = window.localStorage.getItem('EmpCode');

    this.customCalendar = new TimeSheetInfo;
    this.customCalendar.Month = '';
    this.customCalendar.Year = '';
    this.customCalendar.Weeks = [];


    /*------------------------*/
    await this.LoadTimeSheetCalendar();
    //await this.LoadTimeSheetDetails();
    await this.LoadListLeaveTypes();
    await this.LoadListLeaveApplyTypes();
    await this.LoadListTsProject();
    await this.LoadListAnnounce();
    await this.LoadRemarkRevise();
    /*------------------------*/
  }

  ngAfterViewInit() {
    this.customCalendarSizing();
  }

  async LoadTimeSheetCalendar(goToPreviousWeek: Boolean = false) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['MonthValue'] = this.monthValue;
      objectjson['YearValue'] = this.yearValue;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetInfo[]>(this.baseurl + "TimeSheet/GetTimeSheetCalendar",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            this.customCalendar = data[0];
            this.customCalendar.Weeks = data[0].Weeks;
            this.customCalendarSizing();

          }
      ).then(() => {
        var d = new Date();
        var cd = d.getDate();
        var m = d.getMonth()+1;
        var y = d.getFullYear();
        var currentWeek = 0;

        if (m == this.monthValue && y == this.yearValue) {
          for (var _x in this.customCalendar.Weeks) {

            const res = this.customCalendar.Weeks[_x].Days.find((el) => el.IsToday === true);

            if (res) {
              currentWeek = parseFloat(_x);
              break;
            };
          }
        }

        if (goToPreviousWeek) currentWeek = this.weekValue;

        //this.OnSelectDaysList(null, null, currentWeek);
      });
    }
  }
  async LoadTimeSheetDetails() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['MonthValue'] = this.monthValue;
      objectjson['YearValue'] = this.yearValue;

      let strjson = JSON.stringify(objectjson);

      try {
        const data = await this.httpClient.post<TimeSheetDetailInfo[]>(this.baseurl + "TimeSheet/GetTimeSheetDetails", strjson, httpOptions).toPromise();
        this.tsDetails = data;
        this.tsCode = data[0].TimeSheetCode;
      } catch (error) {
        console.error(error);
      }
    }
  }
  async LoadListLeaveTypes() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = JSON.stringify({});
      this.httpClient
        .post<LookupInfo[]>(this.baseurl + "TimeSheet/GetLeaveType",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            this.tsLeaveTypes = data;
          }
        )
    }
  }
  async LoadListLeaveApplyTypes() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = JSON.stringify({});
      this.httpClient
        .post<LookupInfo[]>(this.baseurl + "TimeSheet/GetLeaveApplyType",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            this.tsLeaveApplyTypes = data;
          }
        )
    }
  }


  async btnSaveExpense(projcode) {

    let remark = (<HTMLInputElement>document.getElementById(projcode + '_remark')).value;
    let amount = Number((<HTMLInputElement>document.getElementById(projcode +'_amount')).value);

    let expensetypeselector = (document.getElementById(projcode + '_expensetype')) as HTMLSelectElement;
    let expensetypecode = expensetypeselector.options[expensetypeselector.selectedIndex].value;

    if (expensetypecode == '0') {
      alert('Please select an expense type.');
      return;
    }

    let budgetfortype = this.listofexpensetype.filter(function (el) {
      return el.ExpenseTypeCode == expensetypecode
    })[0].Available;

    if (amount > budgetfortype) {
      alert('Request amount exceeded available budget for specified expense type.');
      return;
    } else if (amount <= 0) {
      alert('Request amount must be more than 0.');
      return;
    }

    if (!confirm("Confirm creating receipt?")) return;

    //alert(projcode + '--' + this.tsHoursDetails[0].TimeSheetDate + '--' + amount + '--' + remark)


    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['RequestBy'] = this._EmpCode;
      objectjson['ReceiptDate'] = this.tsHoursDetails[0].TimeSheetDate;
      objectjson['Amount'] = Number(amount);
      objectjson['Remark'] = remark;
      objectjson['ExpenseTypeCode'] = expensetypecode;
      objectjson['ProjectCode'] = projcode;

      let strjson = JSON.stringify(objectjson);

      let isSubmitted = new SimpleTextInfo();
      this.httpClient
        .post<SimpleTextInfo>(this.expense_baseurl + "ExpenseClaims/SaveExpenseClaimableFromTimesheet",
          strjson, httpOptions)
        .subscribe(result => isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + isSubmitted.Value);
            $('#ModalSaveExpenseSuccess').modal();
          });
    }
  }

  expenseCollapseClearAll() {
    let lmodel = document.querySelectorAll('[id$="_remark"]');
    let lmodel2 = document.querySelectorAll('[id$="_amount"]');

    for (var i = 0; i < lmodel.length; i++) {

      (<HTMLInputElement>lmodel[i]).value = '';
    };

    for (var i = 0; i < lmodel2.length; i++) {

      (<HTMLInputElement>lmodel2[i]).value = '0';
    };

    this.tsMappedProjects.forEach(function (obj) {
      obj.collapsed = false;
    });
  }

  async loadListExpenseTypes(projcode) {

    this.expenseCollapseClearAll();

    if (!projcode) return;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {}
      objectjson['RequestBy'] = this._EmpCode;
      objectjson['ProjectCode'] = projcode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ExpenseClaimsItemInfo[]>(this.baseurl + "ExpenseClaims/GetExpenseClaimable",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            this.listofexpensetype = data;
          }
        )
    }
  }


  async LoadListTsProject() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var _tsCode = this.getTsCode();

      var objectjson = {}
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['TimeSheetCode'] = _tsCode;
      objectjson['ProjectName'] = this.txtSchProjectCodeOrName;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<TimeSheetMappingProjectInfo[]>(this.baseurl + "TimeSheet/GetListTimeSheetMappingProject",
          strjson, httpOptions)
        .toPromise().then(
          data => {

            this.tsMappingProject = data;
            this.tsMappedProjects = data.filter(x => { return x.IsChecked });
            this.totalProject = data.length > 0 ? data.filter(x => { return x.IsChecked }).length : 0;

            if (!!this.weekValue) {
              if (this.customCalendar.Weeks[this.weekValue] != null) {
                var workDays = this.customCalendar.Weeks[this.weekValue].Days.filter(x => { return x.Event.TimesheetType != 5 });
                var startDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[0].Day.toString()).toLocaleDateString('en-CA');
                var endDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[workDays.length - 1].Day.toString()).toLocaleDateString('en-CA');

                //this.LoadListTsHoursDetail(startDate, endDate, workDays);
              }
            } else {
              //this.LoadListTsHoursDetail();
            }
          }
        )
    }
  }
  async LoadListTsHoursDetail(startDate: string = "", endDate: string = "", workDays: any = null) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Set post param
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      
      var _tsCode = !!this.tsCode ? this.tsCode : this.getTsCode();
      var _workDays = workDays;
      var objectjson = {}
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['TimeSheetCode'] = _tsCode;
      objectjson['Month'] = this.monthValue.toString().padStart(2, '0');
      objectjson['Year'] = this.yearValue.toString();

      objectjson['StartDate'] = startDate;
      objectjson['EndDate'] = endDate;

      let strjson = JSON.stringify(objectjson);
      console.log(strjson);

      this.httpClient
        .post<TimeSheetHoursInfo[]>(this.baseurl + "TimeSheet/GetListTimeSheetHours",
          strjson, httpOptions)
        .toPromise().then(
           data =>  {

            console.log("tshour")
            console.log(data)

            if (data.length > 0) {
              //ได้จาก DB
              //this.tsHoursDetails = data;
              //Loop each date
              if (!!_workDays) {
                
                var that = this;
                $(document).ready(function () {
                  //################# start total loop
                  for (var i in _workDays) {
                    var day = _workDays[i];

                    var listdateFiltered = data.filter(x => { return new Date(x.TimeSheetDate).getDate() == new Date(that.yearValue + '-' + that.monthValue.toString().padStart(2, "0") + '-' + (day.Day).toString().padStart(2, "0")).getDate() });
                    var total = 0;
                    for (var h in listdateFiltered) {
                      total += listdateFiltered[h].Hours;
                    }
                    console.log(day.Day);
                    console.log($('#totalOfDay_' + day.Day));
                    console.log(total)
                    $('#totalOfDay_' + day.Day).text(total.toFixed(2));
                    if (Number(total) < 8 && Number(total) > 0) {
                      $('#totalOfDay_' + day.Day).css('color', 'red');
                    } else {
                      $('#totalOfDay_' + day.Day).css('color', 'black');
                    }
                  }
                  //################# end of total loop
                });
              }
              else {

                //Select week แรก
                var workDays = this.customCalendar.Weeks[0].Days;//.filter(x => { return x.Event.TimesheetType != 5 });
                var startDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[0].Day.toString()).toLocaleDateString('en-CA');
                var endDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[workDays.length - 1].Day.toString()).toLocaleDateString('en-CA');

                data = data.filter(x => {
                  return new Date(x.TimeSheetDate).getDate() >= new Date(startDate).getDate()
                    && new Date(x.TimeSheetDate).getDate() <= new Date(endDate).getDate()
                })

                var that = this;
                $(document).ready(function () {
                  //################# start total loop
                  for (var i in workDays) {
                    var day = workDays[i];

                    var listdateFiltered = data.filter(x => { return new Date(x.TimeSheetDate).getDate() == new Date(that.yearValue + '-' + that.monthValue.toString().padStart(2, "0") + '-' + (day.Day).toString().padStart(2, "0")).getDate() });
                    var total = 0;
                    for (var h in listdateFiltered) {
                      total += listdateFiltered[h].Hours;
                    }
                    console.log(day.Day);
                    console.log($('#totalOfDay_' + day.Day));
                    console.log(total)
                    $('#totalOfDay_' + day.Day).text(total.toFixed(2));
                    if (Number(total) < 8 && Number(total) > 0) {
                      $('#totalOfDay_' + day.Day).css('color', 'red');
                    } else {
                      $('#totalOfDay_' + day.Day).css('color', 'black');
                    }
                  }
                  //################# end of total loop
                });
              }

              //Loop project
              this.tsMappedProjects.forEach(async (target, indextarget) => {
                target.Hours = await data.filter(x => { return x.ProjectCode == target.ProjectCode });
                this.tsHoursDetails = target.Hours;
                
                //Generate time
                if (target.Hours.length == 0) {
                  target.Hours = await this.generateHoursDetail(_workDays, target.TimeSheetCode, target.ProjectCode);
                }


                //Sum row
                var total = 0;
                for (var i in target.Hours) {
                  var item = target.Hours[i];
                  total += isNaN(item.Hours) ? 0 : Number(item.Hours)
                }
                $(document).ready(function () {
                  $('#totalOfProject_' + target.ProjectCode).text(total.toFixed(2));
                });
              });
              

            }
            else {
              
              //Gen เอง 
              //Loop project
              this.tsMappedProjects.forEach((target, indextarget) => {
                //Loop hours in each day
                if (Object.keys(this.customCalendar).length > 0) {
                  if (this.customCalendar.Weeks.length > 0) {
                    console.log(_tsCode);

                    if (!!!_workDays) {
                      var firstWeek = this.customCalendar.Weeks[0]; //เอาเฉพาะ week แรก
                      var workDays = firstWeek.Days;//.filter(x => { return x.Event.TimesheetType != 5 });
                      for (var week in this.customCalendar.Weeks) {
                        var firstWeek = this.customCalendar.Weeks[week]; //ถ้า week แรกไม่มีวันทำงานจะลูปหาสัปดาห์ถัดๆไป
                        workDays = firstWeek.Days;//.filter(x => { return x.Event.TimesheetType != 5 });
                        if (workDays.length > 0) {
                          break;
                        }
                      }
                    } else {
                      workDays = _workDays;
                    }

                    workDays = workDays.filter(x => {return x.Day.toString() == this.tempDay});

                    //Loop hours in each day
                    this.tsHoursDetails = [];
                    for (var i in workDays) {
                      var day = workDays[i];
                      var newtsModel = new TimeSheetHoursInfo();
                      newtsModel.TimeSheetCode = this.getTsCode();
                      newtsModel.EmployeeCode = this._EmpCode;
                      newtsModel.UpdateBy = this._EmpCode;
                      newtsModel.CreateBy = this._EmpCode;
                      newtsModel.Hours = 0.00;
                      newtsModel.Detail = "";
                      newtsModel.ProjectCode = target.ProjectCode;

                      var dInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                      var d = new Date(day.Day + ' ' + this.customCalendar.Month + ' ' + this.customCalendar.Year);
                      newtsModel.TimeSheetDate = d.toLocaleDateString('en-CA');
                      newtsModel.Date = day.Day.toString();
                      newtsModel.DayInWeek = dInWeek[d.getDay()];
                      newtsModel.TimesheetTypeCode = day.Event.TimesheetTypeCode

                      //Set Color
                      $('#totalOfDay_' + day.Day).css('color', 'red');

                      //Add to parent array
                      this.tsHoursDetails.push(newtsModel)

                      
                    }

                  }
                }
                //Set hours detail in each project
                target.Hours = this.tsHoursDetails;

                //Sum row
                var total = 0;
                for (var i in target.Hours) {
                  var item = target.Hours[i];
                  total += isNaN(item.Hours) ? 0 : Number(item.Hours)
                }
                $(document).ready(function () {
                  $('#totalOfProject_' + target.ProjectCode).text(total.toFixed(2));
                });
              });

            }
          }
        )
    }
  }
  async LoadListAnnounce() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['FlagActive'] = "Y";
      objectjson['FlagDelete'] = "N";
      objectjson['AnnouncementStartDate'] = new Date(this.yearValue, this.monthValue - 1, 1).toLocaleDateString('en-CA')
      objectjson['AnnouncementEndDate'] = new Date(this.yearValue, this.monthValue - 1, new Date(this.yearValue, this.monthValue,0).getDate()).toLocaleDateString('en-CA')

      let strjson = JSON.stringify(objectjson);
      console.log(strjson);

      this.httpClient
        .post<AnnounceInfo[]>(this.baseurl + "Announcement/GetAnnouncement",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.tsAnnounces = data;
        });
    }
  }
  async LoadRemarkRevise()
  {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var _tsCode = this.getTsCode();
      var objectjson = {};
      objectjson['TimeSheetCode'] = _tsCode
      
      let strjson = JSON.stringify(objectjson);
      console.log(strjson);

      this.httpClient
        .post<any>(this.baseurl + "TimeSheet/GetTimesheetRemarkPendingRevise",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.RemarkRevise = data.Value;
        });
    }
  }

  async OnSelectDaysList(elem: HTMLElement, parentClassName: string, week, day) {

    console.log(day);
    //if (day.Day == null || day.Day == "" || day.Event.TimesheetType == 5) return;
    if (day.Day == null || day.Day == "") return;

    if (day.Day != null && day.Event.TimesheetTypeCode == "leave") {
      console.log("day.Event === ", day.Event);

      let str1 = this.tsLeaveTypes.filter(x => { return x.LookupCode == day.Event.TimesheetLeaveType })[0].LookupValue
      let str2 = this.tsLeaveApplyTypes.filter(x => { return x.LookupCode == day.Event.TimesheetLeaveApplyType })[0].LookupValue

      this.LeaveText = str1 + " - " + str2
    } else {
      this.LeaveText = ""
    }

    //console.log(week)
    this.weekValue = week;

   
    if (this.customCalendar.Weeks[week] != null) {
      var workDays = this.customCalendar.Weeks[week].Days;//.filter(x => { return x.Event.TimesheetType != 5 });
      var selectedDate = new Date(this.yearValue + '-' + this.monthValue + '-' + day.Day).toLocaleDateString('en-CA');
      //var startDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[0].Day.toString()).toLocaleDateString('en-CA');
      //var endDate = new Date(this.yearValue + '-' + this.monthValue + '-' + workDays[workDays.length - 1].Day.toString()).toLocaleDateString('en-CA');

      this.tempDay = day.Day;

      await this.LoadListTsHoursDetail(selectedDate, selectedDate, workDays).then(() => {
        this.OnBtnDayDetailClick();
      });
    }
  }

  async OnPreviousMonthClick() {

    this.monthValue = this.monthValue - 1;
    if (this.monthValue <= 0) {
      this.monthValue = 12;
      this.yearValue = this.yearValue - 1;
    }

    this.tsCode = this.getTsCode();

    /*------------------------*/
    await this.LoadTimeSheetCalendar();
    //await this.LoadTimeSheetDetails();
    await this.LoadListLeaveTypes();
    await this.LoadListLeaveApplyTypes();
    await this.LoadListTsProject();
    //await this.LoadListTsHoursDetail();
    await this.LoadListAnnounce();
    await this.LoadRemarkRevise();
    /*------------------------*/
  }
  async OnNextMonthClick() {

    this.monthValue = this.monthValue + 1;
    if (this.monthValue > 12) {
      this.monthValue = 1;
      this.yearValue = this.yearValue + 1;
    }

    this.tsCode = this.getTsCode();

    /*------------------------*/
    await this.LoadTimeSheetCalendar();
    //await this.LoadTimeSheetDetails();
    await this.LoadListLeaveTypes();
    await this.LoadListLeaveApplyTypes();
    await this.LoadListTsProject();
    //await this.LoadListTsHoursDetail();
    await this.LoadListAnnounce();
    await this.LoadRemarkRevise();
    /*------------------------*/
  }

  async OnBtnAddProjectClick() {
    //await this.OnBtnSaveTsDetailClick();
    this.txtSchProjectCodeOrName = "";

    await this.LoadListTsProject();
    $('#ModalAddProject').modal('show');
  }
  OnBtnGeneralClick() {
    this.selectedLeaveType = "";
    this.selectedLeaveApplyType = 0;
    this.leaveStartDate = null;
    this.leaveEndDate = null;


    $('#ModalApplyGeneral').modal('show');
  }
  OnDdlLeaveApplyTypeChange() {
    if (!!this.selectedLeaveApplyType) {
      $('#tsLeaveEndDate').prop('disabled', this.selectedLeaveApplyType != 1) //Type 1 = Full day
    }
  }

  OnBtnDayDetailClick() {
    this.dataUpdated = false;
    $('#ModalDayDetail').modal('show');
  }
  OnBtnDayDetailCancelClick() {
    this.dataUpdated = false;
    
    $('#ModalDayDetail').modal('hide');
  }

  OnBtnTestClick() {
    this.LoadTimeSheetCalendar();
    this.LoadListTsProject()
  }

  checkifvaluechanged(a, b) {
    if(a != b) this.dataUpdated = true;
  }

  closemodal(){
    if ((this.dataUpdated && confirm("By closing dialog, you will discard any changes made. Continue?"))) {
      this.dataUpdated = false;
      const textarea = document.querySelector('.detailtext') as HTMLTextAreaElement;
      textarea.value = '';
      $('#ModalDayDetail').modal('hide')
    } else {
      $('#ModalDayDetail').modal('hide')
    }
  }

  async OnLeaveStartChange() {
    if (this.leaveEndDate < this.leaveStartDate || this.leaveEndDate == null) this.leaveEndDate = this.leaveStartDate;
  }

  async OnBtnTakeLeaveClick() {

    if (this.leaveEndDate == null) this.leaveEndDate = this.leaveStartDate;

    if (this.selectedLeaveType == "" || this.selectedLeaveApplyType == 0 || this.leaveStartDate == null || this.leaveEndDate == null) {
      alert("Please fill all information before submit")
      return;
    } else if (this.leaveEndDate < this.leaveStartDate) {
      alert("End date cant be earlier than start date")
      return;
    }

    $('#ModalApplyGeneral').modal('hide');

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['LeaveType'] = this.selectedLeaveType;
      objectjson['LeaveApplyType'] = this.selectedLeaveApplyType.toString();
      objectjson['LeaveStartDate'] = this.leaveStartDate;

      if (!!this.selectedLeaveApplyType.toString() && this.selectedLeaveApplyType.toString() == "1") {
        objectjson['LeaveEndDate'] = this.leaveEndDate;
      }

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<boolean>(this.baseurl + "TimeSheet/CreateOrUpdateLeaveDetail",
          strjson, httpOptions)
        .toPromise().then(
         async res_bool => {

            if (res_bool) {
              await this.LoadTimeSheetCalendar();
              await this.LoadListTsProject();
              //await this.LoadTimeSheetDetails();
              //$('#ModalApplyGeneral').modal('hide');
            }

          }
        )
    }
  }
  OnBtnTakeLeaveCancelClick() {
    $('#ModalApplyGeneral').modal('hide');
  }
  async OnBtnSaveProjectClick() {
    //await this.OnBtnSaveTsDetailClick();

    $('#ModalAddProject').modal('hide');

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var listTsProject = [];
      let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var d = new Date();
      var m = monthNames[d.getMonth()];
      var y = d.getFullYear().toString().substr(2, 2);

      var _tsCode = !!this.tsCode ? this.tsCode : "TS-" + window.localStorage.getItem('EmpCode') + "-" + window.localStorage.getItem('EmpFName_EN') + "-" + m + "-" + y;
      console.log(_tsCode.trim());

      $.each($('[name="checkboxProjectDocument"]'), function () {
        var objectjson = {};
        objectjson['EmployeeCode'] = window.localStorage.getItem('EmpCode');
        objectjson['TimeSheetCode'] = _tsCode.trim();
        objectjson['ProjectCode'] = $(this).val();
        objectjson['ProjectType'] = $(this).data('ptype');
        objectjson['IsChecked'] = $(this).prop('checked');

        listTsProject.push(objectjson);
      });

      let strjson = JSON.stringify(listTsProject);
      console.log(listTsProject);

      this.httpClient
        .post<boolean>(this.baseurl + "TimeSheet/CreateOrUpdateListTimeSheetMappingProject",
          strjson, httpOptions)
        .toPromise().then(
          async res_bool => {


            if (res_bool) {
              //await this.OnBtnSaveTsDetailClick();
              await this.LoadTimeSheetDetails();
              await this.SaveTsDetailsToServer();
              await this.LoadListTsProject();
              //$('#ModalAddProject').modal('hide');
            } else
            {
         //     await this.LoadTimeSheetDetails();            
               await this.LoadListTsProject();
            }


          }
        )
    }
  }
  OnBtnAddProjectCancelClick() {
    $('#ModalAddProject').modal('hide');
  }
  OnCheckboxChecked() {
    this.totalProject = $('[name="checkboxProjectDocument"]:checked').length;
    $('#headCheck').prop('checked', this.totalProject == $('[name="checkboxProjectDocument"]').length);

  }

  OnTxtHourKeyup(e) {

    e.target.value = isNaN(parseFloat(e.target.value)) ? "0.00" : parseFloat(e.target.value).toFixed(2).toString();

    //Get data
    var hours = e.target.value;
    var date = $(e.target).data('hourofday');
    var projcode = $(e.target).data('projcode')
    //---------Start Sum in column
    let totalCol = 0
    var listColCtrls = $('.date_' + date);
    $.each(listColCtrls, function (i, val) {
      totalCol += Number($(this).val());
    });
    var totalColElem = $('#totalOfDay_' + date);
    totalColElem.text("");
    totalColElem.text(totalCol.toFixed(2));
    //---------End Sum in column

    //---------Start Sum in row
    let totalRow = 0;
    var listRowCtrls = $('.proj_' + projcode);
    $.each(listRowCtrls, function (i, val) {
      totalRow += Number($(this).val());
    });
    var totalRowElem = $('#totalOfProject_' + projcode);
    totalRowElem.text("");
    totalRowElem.text(totalRow.toFixed(2));
    //---------End Sum in row

    //Detect min hours each day
    if ((totalCol < 8 && totalCol > 0) || totalCol > 24) {
      totalColElem.css('color', 'red');
    } else {
      totalColElem.css('color', 'black');
    }

    return hours;
  }
  
  async OnBtnSaveTsDetailClick(showDialog: Boolean = false) {
    
    if (this.saveTsAllowed) {
      this.saveTsAllowed = false;

      //this.Loading(true, 'Loading...');
        $('#ModalDayDetail').modal('hide');
      this.triggerLoading()
      
      var canSave = await this.SaveTsHoursToServer();
      if (canSave) {
        //await this.SaveTsDetailsToServer(showDialog);
        await this.LoadTimeSheetCalendar();
        await this.LoadListTsProject()

        this.saveTsAllowed = true;
        this.dataUpdated = false;

        if (showDialog) $('#ModalSaveCompleted').modal('show');
      } else {
        $('#ModalDayDetail').modal('show');
      }
      //setTimeout(() => { this.Loading(false, ''); }, 100);
    }

  }

  variableWaiter(vara: any[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const checkData = () => {
        if (vara && vara.length > 0) {
          resolve();
        } else {
          setTimeout(checkData, 100);
        }
      };
      checkData();
    });
  }

  async SaveTsDetailsToServer(showDialog: Boolean = false) {
    
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = this.tsDetails;

      let strjson = JSON.stringify(objectjson);
      console.log(strjson);
      this.httpClient
        .post<boolean>(this.baseurl + "TimeSheet/CreateOrUpdateTimeSheetDetails",
          strjson, httpOptions)
        .toPromise().then(
          data => {
            if (data) {
              this.LoadTimeSheetCalendar();
              //this.LoadTimeSheetDetails();
              this.LoadListTsProject()

              if (showDialog) $('#ModalSaveCompleted').modal('show');
            }
          }
        );//End api connect
    }
    
  }
  async SaveTsHoursToServer() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      //Format data
      let listTsHours: TimeSheetHoursInfo[] = [];

      for (let target of this.tsMappedProjects) {

        target.Hours.forEach((target2, idx2) => {
          let tsHours = new TimeSheetHoursInfo;
          tsHours.Id = target2.Id,
            tsHours.EmployeeCode = this._EmpCode;
          tsHours.TimeSheetCode = target.TimeSheetCode;
          tsHours.TimeSheetDate = target2.TimeSheetDate;
          tsHours.ProjectCode = target.ProjectCode;
          tsHours.Hours = target2.Hours;
          tsHours.CreateBy = this._EmpCode;
          tsHours.UpdateBy = this._EmpCode;
          tsHours.Detail = target2.Detail;

          //Add model to list
          listTsHours.push(tsHours);
        });
      };

      

      var CanSave = true;
      var sumByDate;
      for (let item of this.tsHoursDetails) {
        var totalCol = listTsHours.filter(x => { return x.TimeSheetDate == item.TimeSheetDate }).reduce((a, b) => a + Number(b.Hours), 0);
        if (totalCol > 24) {
          CanSave = false;
          if (listTsHours.filter(x => { return x.TimeSheetDate == item.TimeSheetDate }).length > 0) {
            sumByDate = listTsHours.filter(x => { return x.TimeSheetDate == item.TimeSheetDate })[0];
            sumByDate['Date'] = new Date(sumByDate.TimeSheetDate).getDate();
          }
          break;
        }
      }

      //Send to server
      let strjson = JSON.stringify(listTsHours);
      if (CanSave) {
        CanSave = await this.httpClient
          .post<boolean>(this.baseurl + "TimeSheet/CreateOrUpdateListTimeSheetHours",
            strjson, httpOptions).toPromise();//End api connect
      }
      else {
        if (!!sumByDate) {
          $('#hours_' + sumByDate.ProjectCode + '_OfDay_' + sumByDate.Date).focus()
          $('#totalOfDay_' + sumByDate.Date).css('color', 'red')
        }
        //Alert 
        // this.titlemodal = '';
        // this.detailmodal = 'The working hour should not be greather than 24 hours per a day. \n Day ' + new Date(sumByDate.TimeSheetDate).toLocaleDateString('en-GB');
        // $('#ModalComplate .modal-header').text('Sorry');
        // $('#ModalComplate .modal-header').addClass('bg-purple');
        // $('#ModalComplate .modal-body .btn').addClass('bg-purple');
        // $('#ModalComplate').modal();
        alert("The working hour should not be greather than 24 hours per a day.");
        this.saveTsAllowed = true;
      }

      

      return CanSave;
    }
  }

  async onCancelLeaveEmp(tsHoursDetails: TimeSheetHoursInfo[]){

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      let tsHoursDetail = tsHoursDetails[0];
      console.log("tsHoursDetail...", tsHoursDetail);

      if(tsHoursDetail.TimesheetTypeCode !== "TH00"){

      var objectjson = {}
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['TimeSheetCode'] = tsHoursDetail.TimeSheetCode;
      objectjson['TimesheetTypeCode'] = tsHoursDetail.TimesheetTypeCode;
      
      objectjson['TimeSheetDateStatusCode'] = 3;
      objectjson['TimeSheetDate'] = tsHoursDetail.TimeSheetDate;

      console.log(objectjson);


    //  return await this.httpClient
    //       .delete<boolean>(this.baseurl + "TimeSheet/CancelLeaveDetail", httpOptions).toPromise();

    return await this.httpClient.request('DELETE', this.baseurl + "TimeSheet/CancelLeaveDetail", {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
            }),
            body: objectjson
        }).toPromise().then(data => {
          console.log(data);
          if(data){
              $('#ModalDayDetail').modal('hide');
              this.triggerLoading();

              this.LoadTimeSheetCalendar();
              this.LoadListTsProject()
          }
        }).catch(err => {
          console.error(err);
        });


      }

    }

  }

  /*---------------------- Private function -------------------- */
  triggerLoading() {
    this.LoadingManualTrigger = true;
    this.LoadingManualTrigger = false;
  }

  getTsCode(): string {
    let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


    if (!!this.monthValue && !!this.yearValue) {
      var m = monthNames[this.monthValue - 1];
      var y = this.yearValue.toString().substr(2, 2);
      return "TS-" + window.localStorage.getItem('EmpCode') + "-" + window.localStorage.getItem('EmpFName_EN') + "-" + m + "-" + y;
    } else {
      var d = new Date();
      var m = monthNames[d.getMonth()];
      var y = d.getFullYear().toString().substr(2, 2);
      return "TS-" + window.localStorage.getItem('EmpCode') + "-" + window.localStorage.getItem('EmpFName_EN') + "-" + m + "-" + y;
    }

  }

  customCalendarSizing() {
    $('.custom-calendar-table').ready(function () {
      var tbl = $('.custom-calendar-table');

      var maxTdLength = tbl[0].offsetWidth / 7;
      if (maxTdLength == 0)
        maxTdLength = 70;

      $('.custom-calendar-table td').css('width', maxTdLength + 'px');
      var height = maxTdLength * 0.7;
      $('.custom-calendar-table td').css('height', parseInt(height.toString()) + 'px');
    });
  }

  chkallclick(target) {
    var check = $(target.currentTarget).is(":checked");
    $('[name="checkboxProjectDocument"]').prop('checked', check);

    this.totalProject = $('[name="checkboxProjectDocument"]:checked').length;

  }

  createItemTsHoursDefault(): FormGroup {
    return this.formBuilder.group({
      Id: [0],
      EmployeeCode: [''],
      TimeSheetCode: [''],
      TimeSheetDate: [''],
      ProjectCode: [''],
      Hours: [0],
      Date: [''],
      DayInWeek: [''],
      CreateDate: [''],
      CreateBy: [''],
      UpdateDate: [''],
      UpdateBy: [''],
      Detail: ['']
    },
      {
        // Used custom form validator 
      }
    );
  }

  createItemTsHour(tsHour: TimeSheetHoursInfo): FormGroup {

    var dInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    var d = new Date(tsHour.TimeSheetDate);

    return this.formBuilder.group({
      Id: [tsHour.Id],
      EmployeeCode: [tsHour.EmployeeCode],
      TimeSheetCode: [tsHour.TimeSheetCode],
      TimeSheetDate: [tsHour.TimeSheetDate],
      ProjectCode: [tsHour.ProjectCode],
      Hours: [tsHour.Hours],
      Date: [d.getDate()],
      DayInWeek: [dInWeek[d.getDate()]],
      CreateDate: [tsHour.CreateDate],
      CreateBy: [tsHour.CreateBy],
      UpdateDate: [tsHour.UpdateDate],
      UpdateBy: [tsHour.UpdateBy],
      Detail: [tsHour.Detail]
    },
      {
        // Used custom form validator 
      }
    );
  }

  async generateHoursDetail(_workDays, _tsCode, _ProjectCode)
  {
    //Loop hours in each day
    if (Object.keys(this.customCalendar).length > 0) {
      if (this.customCalendar.Weeks.length > 0) {
        console.log(_tsCode);

        if (!!!_workDays) {
          var firstWeek = this.customCalendar.Weeks[0]; //เอาเฉพาะ week แรก
          var workDays = firstWeek.Days.filter(x => { return x.Event.TimesheetType != 5 });
          for (var week in this.customCalendar.Weeks) {
            var firstWeek = this.customCalendar.Weeks[week]; //ถ้า week แรกไม่มีวันทำงานจะลูปหาสัปดาห์ถัดๆไป
            workDays = firstWeek.Days.filter(x => { return x.Event.TimesheetType != 5 });
            if (workDays.length > 0) {
              break;
            }
          }
        }
        else {
          workDays = _workDays;
        }

        workDays = workDays.filter(x => {return x.Day.toString() == this.tempDay});

        //Loop hours in each day
        this.tsHoursDetails = [];
        for (var i in workDays) {
          var day = workDays[i];
          var newtsModel = new TimeSheetHoursInfo();
          newtsModel.TimeSheetCode = this.getTsCode();
          newtsModel.EmployeeCode = this._EmpCode;
          newtsModel.UpdateBy = this._EmpCode;
          newtsModel.CreateBy = this._EmpCode;
          newtsModel.Hours = 0.00;
          newtsModel.Detail = "";
          newtsModel.ProjectCode = _ProjectCode;

          var dInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
          var d = new Date(day.Day + ' ' + this.customCalendar.Month + ' ' + this.customCalendar.Year);
          newtsModel.TimeSheetDate = d.toLocaleDateString('en-CA');
          newtsModel.Date = day.Day.toString();
          newtsModel.DayInWeek = dInWeek[d.getDay()];
          newtsModel.TimesheetTypeCode = day.Event.TimesheetTypeCode;

          //Set Color
          $('#totalOfDay_' + day.Day).css('color', 'red');

          //Add to parent array
          this.tsHoursDetails.push(newtsModel)
        }

        return this.tsHoursDetails;
      }
    }
  }

  calculateHours() {
    //Get data
    //var hours = e.target.value;
    //var date = $(e.target).data('hourofday');
    //var projcode = $(e.target).data('projcode');

    ////---------Start Sum in column
    //let totalCol = 0
    //var listColCtrls = $('.date_' + date);
    //$.each(listColCtrls, function (i, val) {
    //  totalCol += Number($(this).val());
    //});
    //var totalColElem = $('#totalOfDay_' + date);
    //totalColElem.text("");
    //totalColElem.text(totalCol.toFixed(2));
    ////---------End Sum in column

    ////---------Start Sum in row
    //let totalRow = 0;
    //var listRowCtrls = $('.proj_' + projcode);
    //$.each(listRowCtrls, function (i, val) {
    //  totalRow += Number($(this).val());
    //});
    //var totalRowElem = $('#totalOfProject_' + projcode);
    //totalRowElem.text("");
    //totalRowElem.text(totalRow.toFixed(2));
    ////---------End Sum in row

    ////Detect min hours each day
    //if (totalCol < 8) {
    //  totalColElem.css('color', 'red');
    //} else {
    //  totalColElem.css('color', 'black');
    //}
  }
  numberRemoveCommas(x) {
    return x.replace(/,/g, '');
  }
  numberWithCommas(x) {
    x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (x.indexOf('.') < 0)
      x += ".00";
    return x
  }

  OnSearchProjectKeyUp() {
    this.LoadListTsProject();
  }

  Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
}
